import React, { useCallback, useMemo } from "react";
import { useAuth } from "../../../../firebase/AuthProvider";
import { TaskAssignee } from "../../../../interfaces/task/TaskAssignee";
import { TaskCommentRequest } from "../../../../interfaces/taskAction/TaskCommentRequest";
import { createCommentOnTaskId } from "../../../../services/taskServices/TaskActionService";
import ChatInput from "./ChatInput"; // New Component
import ChatMessageList from "./ChatMessageList"; // New Component
import { useChatData } from "../../../../hooks/taskChatHooks/useChatData";
import { useTaskChat } from "../../../../hooks/taskChatHooks/useTaskChat";
import { getChatsForTask } from "../../../../services/taskServices/TaskCommentsService";
import "./ChatMessageList.css";

interface TaskChatComponentProps {
  taskId: string;
  assignees: TaskAssignee[];
  onCommentAdded?: (count: number) => void;
}

const TaskChatComponent: React.FC<TaskChatComponentProps> = ({ taskId, assignees, onCommentAdded }) => {
  const { currentUser } = useAuth();
  
  // Custom hook to manage fetching users and avatars
  const { users, avatars, isLoading: isDataLoading } = useChatData();

  // Custom hook to manage SignalR connection and chat messages
  const { chats, sendMessage, isLoading: isChatLoading, setChats, setIsLoading} = useTaskChat(taskId);

  // Memoize the Audio object for the sent sound
  const sendSound = useMemo(() => new Audio('/sounds/message-sent.mp3'), []);

  const handleSubmitComment = useCallback(async (commentData: TaskCommentRequest) => {
    if (!currentUser) return;

    sendSound.play().catch(e => console.error("Error playing sound:", e));

    // 1. Send via SignalR for real-time update
    const userIds = assignees.map((item) => item.user.id);
    sendMessage(commentData.description, userIds);

    // 2. Persist the comment to the database
    const authToken = await currentUser.getIdToken();
    await createCommentOnTaskId(commentData, authToken);
    fetchTaskChats();

    // The SignalR hook will automatically add the new message to the chat list
  }, [currentUser, sendMessage, assignees]);


const fetchTaskChats = async () => {
      if (taskId && currentUser) {
        setIsLoading(true);
        const authToken = await currentUser.getIdToken();
        const fetchedChats = await getChatsForTask(taskId, authToken);
        if (fetchedChats) {
          setChats(fetchedChats);
          onCommentAdded && onCommentAdded(fetchedChats.length);
        }
        setIsLoading(false);
      }
    };

  if (isDataLoading || isChatLoading) {
    return (
      <div className="chat-loading-container">
        <div className="chat-loading-spinner"></div>
        <p className="chat-loading-text">Loading...</p>
      </div>
    );
  }

  console.log("Chats", chats)
  return (
    <>
      <ChatMessageList
        chats={chats}
        users={users}
        avatars={avatars}
        currentUserId={currentUser?.uid}
      />
      <div className="chat_footer">
        <ChatInput
          users={users || []}
          avatars={avatars || []}
          onSubmit={handleSubmitComment}
          taskId={taskId}
        />
      </div>
    </>
  );
};

export default TaskChatComponent;